import React from 'react';
import { motion } from 'framer-motion';
import { NeonButton } from './NeonButton';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/noEb8q6RZ64AzhguvHbyeS/WhatsApp_Image_2026-04-15_at_16.02.36_(1).jpg';
export const Hero: React.FC = () => {
  return <section id="inicio" className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden" data-id="element-87">
      <div className="max-w-4xl mx-auto px-6 text-center z-10" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-8 flex justify-center" data-id="element-89">
          <div className="relative" data-id="element-90">
            <div className="absolute inset-0 rounded-full bg-neon-blue/20 blur-2xl animate-pulse" data-id="element-91" />
            <img src={LOGO_URL} alt="Impulsador Digital" className="w-40 h-40 md:w-56 md:h-56 rounded-full border-2 border-white/10 shadow-[0_0_30px_rgba(0,207,255,0.3)] relative z-10" data-id="element-92" />
          </div>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight" data-id="element-93">
          Si no tenés página web, estás{' '}
          <span className="text-neon-blue text-glow" data-id="element-94">perdiendo clientes.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-lg md:text-xl text-silver mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-95">
          Los clientes buscan en Google, no solo en Instagram o Facebook. Si tu
          negocio no aparece, tu competidor se lleva el cliente.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-96">
          <NeonButton href="https://wa.me/5493416660996" className="text-lg px-10 py-5" data-id="element-97">
            Impulsar mi negocio
          </NeonButton>
        </motion.div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-dark-bg to-transparent pointer-events-none" data-id="element-98" />
    </section>;
};